module.exports = __webpack_public_path__ + "static/media/rainbow_shadow.72edf957.png";